import { render, staticRenderFns } from "./Payee.vue?vue&type=template&id=5f1d9e62&"
import script from "./Payee.vue?vue&type=script&lang=js&"
export * from "./Payee.vue?vue&type=script&lang=js&"
import style0 from "./Payee.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports